import { CSSProperties } from 'react';

type FontColorProps = {
  color?: CSSProperties['color'];
  size?: number;
};

const FontColor = ({ color, size }: FontColorProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fill="#6D6D82"
        d="M12.6937 5.46563C12.5781 5.18438 12.3063 5 12 5C11.6937 5 11.4219 5.18438 11.3063 5.46563L6.39375 17.5H5.75C5.33437 17.5 5 17.8344 5 18.25C5 18.6656 5.33437 19 5.75 19H9.25C9.66563 19 10 18.6656 10 18.25C10 17.8344 9.66563 17.5 9.25 17.5H8.01562L9.0375 15H14.9688L15.9906 17.5H14.75C14.3344 17.5 14 17.8344 14 18.25C14 18.6656 14.3344 19 14.75 19H18.25C18.6656 19 19 18.6656 19 18.25C19 17.8344 18.6656 17.5 18.25 17.5H17.6062L12.6937 5.46563ZM14.3531 13.5H9.64687L12 7.73438L14.3531 13.5Z"
      />
      <rect x="5" y="20" width="14" height="2" fill={color} />
    </svg>
  );
};

export default FontColor;
